import { SaveButton } from '../../components/admin/form';
import {
  FormToolbar,
  type FormToolbarProps,
} from '../../components/admin/simple-form';

/** Form toolbar with only the save button (no cancel button, unlike the kit default). */
export const MoonstarEditFormToolbar = (props: FormToolbarProps) => {
  return (
    <FormToolbar {...props}>
      <div className="flex flex-row justify-end gap-2">
        <SaveButton />
      </div>
    </FormToolbar>
  );
};
